module.exports = __webpack_public_path__ + "static/logo_impact.76cac586.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/partners/logo_impact.png
// module id = 579
// module chunks = 37581630142331